import { lazyLoadView } from '@router/helpers';

export default [
  {
    path: '/:operator/:id(\\d+)/organisasi',
    name: 'organisasi',
    component: () => lazyLoadView(import('@views/admin/organisasi/List.vue')),
    meta: {
      title: 'Organisasi',
    },
  },
  {
    path: '/:operator/:id(\\d+)/organisasi/:organisasi_id(\\d+)',
    name: 'organisasi-detil',
    component: () => lazyLoadView(import('@views/admin/organisasi/Detail.vue')),
    meta: {
      title: 'Profil Organisasi',
    },
  },
];
